import { fetchAuthenticatedUser } from "./userActions/loginActions";
import { APIEndpoints, APIPaths } from "../../AWS/APIEndpoints";
import { initializeAPIOptions } from "../../../Utils/API";
import { API } from "aws-amplify";

export const SET_DAEMONS_LIST = "SET_DAEMONS_LIST";
export const SET_DAEMON_DETAILS = "SET_DAEMON_DETAILS";
export const SET_FOUND_DAEMON_INFO = "SET_FOUND_DAEMON_INFO";

export const setDaemonsList = (daemonsList) => ({
    type: SET_DAEMONS_LIST,
    payload: daemonsList,
});

export const setDaemonDetails = (daemonDetails) => ({
    type: SET_DAEMON_DETAILS,
    payload: daemonDetails,
});

export const setFoundDaemonInfo = (daemonInfo) => ({
    type: SET_FOUND_DAEMON_INFO,
    payload: daemonInfo,
});

export const searchDaemon = (orgId, serviceId) => async (dispatch) => {
    try {
        if (!orgId || !serviceId) return;
        const { token } = await dispatch(fetchAuthenticatedUser());

        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.SEARCH_DAEMON;

        const apiOptions = initializeAPIOptions(token, null, { orgId, serviceId });

        const response = await API.get(apiName, apiPath, apiOptions);

        dispatch(setFoundDaemonInfo(response?.data));
        return response?.data;
    } catch (error) {
        console.error(error?.message || "Unknown error on search daemon");
    }
};
